<template>
  <div class="earth-3d" ref="earth3dRef" id="earth3dRef"></div>
</template>

<script>
import * as echarts from "echarts"
import "echarts-gl"

export default {
  props: {
    optionsData: Array
  },
  data() {
    return {
      myChart: null,
      options: null,
      selectedIndex: "",
      hoveredIndex: "",
      seriesIndex: 0,
      intervalId: null
    }
  },
  mounted() {
    // this.init()
  },
  beforeDestroy() {
    // 清理定时器
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
    if (this.myChart) {
      this.myChart.dispose()
    }
  },
  methods: {
    /**
     * 将数组等比例缩放到指定范围 [newMin, newMax]，保持数据顺序不变,原始数据过大造成饼图升得太高
     * @param {Array} arr - 原始数值数组，如 [20, 80, 500, 600]
     * @param {number} newMin - 缩放后的最小值，默认为1
     * @param {number} newMax - 缩放后的最大值，默认为60
     * @returns {Array} 缩放后的数组，顺序不变
     */
    scaleArray(arr, newMin = 1, newMax = 60) {
      // 处理空数组情况
      if (arr.length === 0) {
        return []
      }

      // 找到数组中的最小值和最大值
      const min = Math.min(...arr)
      const max = Math.max(...arr)

      // 如果所有值都相同，特殊处理
      if (max === min) {
        // 返回所有值为目标范围的中点（取整）
        const midValue = Math.round((newMin + newMax) / 2)
        return arr.map(() => midValue)
      }

      // 使用最小-最大归一化公式进行缩放，并四舍五入为整数
      return arr.map((value) => {
        // 先将值归一化到 [0, 1] 范围
        const normalized = (value - min) / (max - min)
        // 然后将归一化值缩放到目标范围 [newMin, newMax]，并四舍五入为整数
        return Math.round(normalized * (newMax - newMin) + newMin)
      })
    },
    init (data) {
     this.myChart =null,
     this.options=null,
     this.selectedIndex="",
     this.hoveredIndex="",
     this.seriesIndex=0,
     this.intervalId=null

      // console.log('实例调用==',data);
      // console.log("组件数据=====", this.optionsData)
      this.myChart = echarts.init(this.$refs.earth3dRef)
      if (!data.length) {
        return;
      }
      //   this.optionsData,
      const numArr = data.map((va) => va.value)
      const newNumArr = this.scaleArray(numArr)
      const newEchartsData = data.map((va, i) => {
        va["num"] = newNumArr[i]
        return va
      })
      console.log(
        "numArr",
        numArr,
        "修改后的值====",
        this.scaleArray(numArr),
        "真实数据修改",
        newEchartsData
      )
      const mock = [
        {
          name: "水田",
          value: 60,
          itemStyle: {
            color: "#1890FF"
          }
        },
        {
          name: "水浇地",
          value: 440,
          itemStyle: {
            color: "#1EE7E7"
          }
        },
        {
          name: "旱地",
          value: 32,
          itemStyle: {
            color: "#F3F62B"
          }
        }
      ]

      // 生成3D饼图配置
      this.options = this.getPie3D(newEchartsData, 0.59)

      // 设置初始标题
      this.options.title.text =
        this.options.series[0].name + " " + this.options.series[0].pieData.value

      // 渲染图表
      this.myChart.setOption(this.options)
      console.log("options====", this.options)

      // 绑定事件
      this.bindEvents()

      // 设置自动轮播
      this.setupAutoRotation()
    },

    // 生成扇形的曲面参数方程
    getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, h) {
      const midRatio = (startRatio + endRatio) / 2
      const startRadian = startRatio * Math.PI * 2
      const endRadian = endRatio * Math.PI * 2
      const midRadian = midRatio * Math.PI * 2

      // 如果只有一个扇形，则不实现选中效果
      if (startRatio === 0 && endRatio === 1) {
        isSelected = false
      }

      // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
      k = typeof k !== "undefined" ? k : 1 / 3

      // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
      const offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0
      const offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0

      // 计算高亮效果的放大比例（未高亮，则比例为 1）
      const hoverRate = isHovered ? 1.05 : 1

      // 返回曲面参数方程
      return {
        u: {
          min: -Math.PI,
          max: Math.PI * 3,
          step: Math.PI / 32
        },
        v: {
          min: 0,
          max: Math.PI * 2,
          step: Math.PI / 20
        },
        x(u, v) {
          if (u < startRadian) {
            return (
              offsetX +
              Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate
            )
          }
          if (u > endRadian) {
            return (
              offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate
            )
          }
          return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate
        },
        y(u, v) {
          if (u < startRadian) {
            return (
              offsetY +
              Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate
            )
          }
          if (u > endRadian) {
            return (
              offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate
            )
          }
          return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate
        },
        z(u, v) {
          if (u < -Math.PI * 0.5) {
            return Math.sin(u)
          }
          if (u > Math.PI * 2.5) {
            return Math.sin(u) * h * 0.1
          }
          return Math.sin(v) > 0 ? 1 * h * 0.1 : -1
        }
      }
    },

    // 生成模拟 3D 饼图的配置项
    getPie3D(pieData, internalDiameterRatio) {
      const series = []
      let sumValue = 0
      let startValue = 0
      let endValue = 0
      const legendData = []
      const k =
        typeof internalDiameterRatio !== "undefined"
          ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio)
          : 1 / 3

      // 为每一个饼图数据，生成一个 series-surface 配置
      for (let i = 0; i < pieData.length; i += 1) {
        // sumValue += pieData[i].value
        sumValue += pieData[i].num

        const seriesItem = {
          name: pieData[i].name || `series${i}`,
          type: "surface",
          parametric: true,
          wireframe: {
            show: false
          },
          pieData: pieData[i],
          pieStatus: {
            selected: false,
            hovered: false,
            k
          }
        }

        if (pieData[i].itemStyle) {
          seriesItem.itemStyle = { ...pieData[i].itemStyle }
        }
        series.push(seriesItem)
      }

      // 为每个扇形生成参数方程
      for (let i = 0; i < series.length; i += 1) {
        // endValue = startValue + series[i].pieData.value
        endValue = startValue + series[i].pieData.num

        series[i].pieData.startRatio = startValue / sumValue
        series[i].pieData.endRatio = endValue / sumValue
        series[i].parametricEquation = this.getParametricEquation(
          series[i].pieData.startRatio,
          series[i].pieData.endRatio,
          false,
          false,
          k,
          //   series[i].pieData.value === series[0].pieData.value ? 35 : 10
          series[i].pieData.num === series[0].pieData.num ? 35 : 10
        )

        startValue = endValue
        legendData.push(series[i].name)
      }

      // 返回配置项
      return {
        legend: {
          show: true,
          orient: "vertical",
          // 距离容器右侧10像素:cite[2]:cite[4]:cite[8]
          right: 10,
          // 在容器中垂直居中显示:cite[1]:cite[2]:cite[4]
          top: "center",
          // 可根据需要设置图例的宽度，避免文字过长溢出:cite[1]:cite[3]
          width: 100,
          textStyle: {
            color: "#fff" // 设置文字颜色为红色
          }
        },
        title: {
          text: "年审核问题分布情况",
          left: "32%", // 水平居中[2](@ref)
          top: "34%", // 垂直居中（与'50%'效果相同）[8](@ref
          textStyle: {
            // color: "#7ce6dd",
            color: "#fff",
            fontSize: 14
          }
        },
        tooltip: {
          formatter: (params) => {
            if (params.seriesName !== "mouseoutSeries") {
              return `${
                params.seriesName
              }<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${
                params.color
              };"></span>${series[params.seriesIndex].pieData.value}`
            }
            return ""
          }
        },
        xAxis3D: {
          min: -1,
          max: 1
        },
        yAxis3D: {
          min: -1,
          max: 1
        },
        zAxis3D: {
          min: -1,
          max: 1
        },
        grid3D: {
          show: false,
          boxHeight: 4,
          //   top: "-20%",

          left: 0, // 将图表位置设置为最左边
          top: "-10%", // 垂直居中
          width: "80%", // 根据需要调整宽度
          height: 200, // 固定高度
          viewControl: {
            alpha: 20,
            rotateSensitivity: 1,
            zoomSensitivity: 0,
            panSensitivity: 0,
            distance: 122 // 设置大小
          },
          postEffect: {
            enable: false,
            bloom: {
              enable: true,
              bloomIntensity: 0.1
            },
            SSAO: {
              enable: true,
              quality: "medium",
              radius: 2
            }
          }
        },
        series
      }
    },

    // 处理鼠标悬停事件
    handleOver(params) {
      // 如果触发 mouseover 的扇形当前已高亮，则不做操作
      if (this.hoveredIndex === params.seriesIndex) {
        return
      }

      // 如果当前有高亮的扇形，取消其高亮状态
      if (this.hoveredIndex !== "") {
        this.cancelHighlight(this.hoveredIndex)
        this.hoveredIndex = ""
      }

      // 如果触发 mouseover 的扇形不是透明圆环，将其高亮
      if (params.seriesName !== "mouseoutSeries") {
        this.highlightSlice(params.seriesIndex)
        this.hoveredIndex = params.seriesIndex
      }

      // 使用更新后的 option，渲染图表
      this.myChart.setOption(this.options)
    },

    // 高亮指定扇形
    highlightSlice(index) {
      const seriesItem = this.options.series[index]
      const isSelected = seriesItem.pieStatus.selected
      const isHovered = true
      const startRatio = seriesItem.pieData.startRatio
      const endRatio = seriesItem.pieData.endRatio
      const k = seriesItem.pieStatus.k

      // 更新标题
      this.options.title.text = seriesItem.name + " " + seriesItem.pieData.value

      // 更新参数方程以实现高亮效果
      seriesItem.parametricEquation = this.getParametricEquation(
        startRatio,
        endRatio,
        isSelected,
        isHovered,
        k,
        seriesItem.pieData.num + 5
      )
      seriesItem.pieStatus.hovered = isHovered
    },

    // 取消高亮指定扇形
    cancelHighlight(index) {
      const seriesItem = this.options.series[index]
      const isSelected = seriesItem.pieStatus.selected
      const isHovered = false
      const startRatio = seriesItem.pieData.startRatio
      const endRatio = seriesItem.pieData.endRatio
      const k = seriesItem.pieStatus.k
      const height =
        seriesItem.pieData.num === this.options.series[0].pieData.num ? 35 : 10

      // 更新参数方程以取消高亮效果
      seriesItem.parametricEquation = this.getParametricEquation(
        startRatio,
        endRatio,
        isSelected,
        isHovered,
        k,
        height
      )
      seriesItem.pieStatus.hovered = isHovered
    },

    // 处理鼠标移出事件
    handleOut() {
      if (this.hoveredIndex !== "") {
        this.cancelHighlight(this.hoveredIndex)
        this.hoveredIndex = ""
        this.myChart.setOption(this.options)
      }
    },

    // 绑定事件
    bindEvents() {
      // 使用箭头函数确保this指向正确
      this.myChart.on("mouseover", (params) => {
        this.handleOver(params)
      })

      this.myChart.on("globalout", () => {
        this.handleOut()
      })
    },

    // 设置自动轮播
    setupAutoRotation() {
      this.intervalId = setInterval(() => {
        this.handleOver({ seriesIndex: this.seriesIndex })
        this.seriesIndex++
        if (this.seriesIndex === this.options.series.length) {
          this.seriesIndex = 0
        }
      }, 3000)
    }
  }
}
</script>

<style scoped>
.earth-3d {
  width: 100%;
  height: 100%;
  min-height: 200px; /* 确保有足够的高度显示图表 */
}
</style>
